import React from 'react';
import styled from 'styled-components'

const NotFound = styled.div`height: 100vh`;
const H1 = styled.h1`font-size: 124px;`;
const P = styled.p`font-size: 40px;`;
const SPAN = styled.span`font-size: 24px;`;

function PageNotFound(props) {
    return (
        <div className='bg-black'>
            <NotFound className='d-flex justify-content-center align-items-center'>
                <div className='text-center'>
                    <H1 className='text-grey m-0'>404</H1>
                    <P className='text-grey m-0'>PAGE NOT FOUND</P>
                    <SPAN className='text-grey m-0'>The page you are looking for is currently not available</SPAN>
                </div>
            </NotFound>
        </div>
    );
}

export default PageNotFound;